export default class SocialShare {

    constructor() {
        this.social = document.querySelector('.cp-share-social');
        if (this.social === null) return;

        this.bnSocial = document.querySelector('.js-btn-open-social');
        this.bnSocial.addEventListener('click', () => {
            this.openSocialShare();
        });
    }

    openSocialShare() {
        document.querySelector('body').classList.contains('open-social') ? document.querySelector('body').classList.remove('open-social') : document.querySelector('body').classList.add('open-social');
    }

    closeSocialShare() {
        document.querySelector('body').classList.remove('open-social');
    }
}